import React, { useState, useEffect } from "react";
import {
  Toast,
  PaginationDiscovery,
  SelectInput,
  SelectInputFilter,
  ModalConfirmDeleteInfluencer,
  ModalAddInfToList,
} from "../../Components";
import "rc-slider/assets/index.css";
import ModalLocation from "./ModalLocation";
import ModalPrice from "./ModalPrice";
import ModalAge from "./ModalAge";
import ModalEthnicity from "./ModalEthnicity";
import ModalLanguage from "./ModalLanguage";
import { AnimatePresence } from "framer-motion";
import Modal from "../../Components/Base/Modal";
import CardInfluencerSearch from "./CardInfluencerSearch";
import AddListandInfluencerToList from "./AddListandInfluencerToList";
import { influencerlistService } from "../../Services";
import ModalNotSubscribe from "../../Components/Base/Common/Modal/ModalNotSubscribe";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { LayoutGrid, List, X } from "lucide-react";
import { SwitchWithLabel } from "../../Components/AppSwitchWithLabel";
import ListInfluencerSearch from "./ListInfluencerSearch";
import ModalFollowers from "./ModalFollowers";
import ModalSearchSubscription from "../../Components/Base/Common/Modal/ModalSearchSubscription";

export default function SearchInfMain({
  setPage,
  selectedCategory,
  inputValue,
  setInputValue,
  isLoadedInfluencer,
  setIsUserHasAccessListing,
  onPaginate,
  paginationData,
  selectedPrice,
  selectedFollowersCount,
  influncerList,
  profiles,
  setStartSearch,
  startSearch,
  setSelectedCategory,
  selectedLocationData,
  setSelectedLocationData,
  countries,
  selectedEthenicity,
  selectedLanguage,
  isUserHasSubscription,
  selectedGender,
  setSelectedGender,
  clearAll,
  setSelectedPrice,
  categoriesData,
  setSelectedFollowersCount,
  setSelectedAge,
  selectedAge,
  setSelectedProduct,
  selectedPlatform,
  platform,
  productList,
  setSelectedEthenicity,
  setSelectedLanguage,
  changeSelectedPlatform,
  selectedProduct,
  goToPricing,
  cartItem,
  closeCartPanel,
  setAuth,
  user,
  NotifModul,
  setModalNotification,
  locationData,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [modal, setModal] = useState(null);
  const [genderIsOpen, setGenderIsOpen] = useState(false);
  const [toastList, setToastList] = useState([]);
  const [selectedInfluencer, setSelectedInfluencer] = useState({});
  const [isSubscribeModal, setIsSubscribeModal] = useState(false);
  const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  const [showList, setShowList] = useState(false);

  const navigate = useNavigate();
  const gender = [
    { value: "m", label: "Male" },
    { value: "f", label: "Female" },
    { value: "o", label: "Other" },
  ];
  const toggleDropdown = () => {
    setGenderIsOpen(false);
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    if (
      selectedPlatform === "" ||
      selectedPlatform === "Any" ||
      productList.length === 0
    ) {
      setIsOpen(false);
    }
  }, [selectedPlatform, productList]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest(".category-input-container") &&
        !event.target.closest('[style*="position: absolute"]') &&
        !event.target.closest(".category-dropdown")
      ) {
        setCategoryDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleCheckboxChange = (option) => {
    if (selectedProduct.includes(option.id)) {
      setSelectedProduct(selectedProduct.filter((item) => item !== option.id));
    } else {
      setSelectedProduct([...selectedProduct, option.id]);
    }
  };
  const removeFromList = async (influencer) => {
    try {
      console.log(influencer);
      let option = {
        inf_user_id: influencer.id,
        inf_user_type: influencer.type,
      };
      const res = await influencerlistService.removeFromList(
        influencer.list_id,
        option
      );
      console.log(res);
      addToast({
        error: false,
        msg: res.message,
        id: `${Date.now()}-${toastList.length}`,
      });
      handleSearch();
    } catch (err) {
      addToast({
        error: true,
        msg: err,
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  };
  const handleButtonClick = () => {
    setSelectedProduct([]);
  };
  const handleSearch = () => {
    setStartSearch(!startSearch);
    setModal(null);
    setIsOpen(false);
    setGenderIsOpen(false);
    setPage(1);
  };
  const handleSearchNew = () => {
    setModal(null);
    setIsOpen(false);
    setGenderIsOpen(false);
    setStartSearch(!startSearch);
    setPage(1);
  };
  const handleClearButtonClick = () => {
    setSelectedGender("");
  };

  const changeSelectedGender = (item) => {
    setSelectedGender(item.value);
  };

  const toggleDropdownGender = () => {
    setIsOpen(false);
    setGenderIsOpen(false);
    setGenderIsOpen(!genderIsOpen);
  };

  const showFollowerModal = () => {
    setIsOpen(false);
    setGenderIsOpen(false);
    setModal("followers");
  };
  const showLocationModal = () => {
    setIsOpen(false);
    setGenderIsOpen(false);
    setModal("location");
  };
  const showPriceModal = () => {
    setIsOpen(false);
    setGenderIsOpen(false);
    setModal("price");
  };
  const showAgeModal = () => {
    setIsOpen(false);
    setGenderIsOpen(false);
    setModal("age");
  };
  const showEthnicityModal = () => {
    setIsOpen(false);
    setGenderIsOpen(false);
    setModal("ethnicity");
  };
  const showLanguageModal = () => {
    setIsOpen(false);
    setGenderIsOpen(false);
    setModal("language");
  };
  const addToast = (data) => {
    const newToastList = [...toastList];
    if (data.msg) {
      if (data.msg[data.msg.length - 1] === ".")
        data.msg = data.msg.slice(0, -1);
    }
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };

  // const [categoriesNewData, setCategoriesNewData] = useState([
  //   { id: "1", name: "React" },
  //   { id: "2", name: "Node.js" },
  //   { id: "3", name: "TypeScript" },
  // ]);

  // const handleCreate = (inputValue) => {
  //   const value =
  //     typeof inputValue === "string"
  //       ? inputValue
  //       : inputValue.name || inputValue.label || "";

  //   const newItem = value.trim();
  //   const option = {
  //     id: Date.now().toString(),
  //     name: newItem,
  //   };
  //   setCategoriesNewData((prev) => [...prev, option]);
  //   return option;
  // };

  // UPDATED: handleKeyDown function
  const handleKeyDown = (e) => {
    if (e.key === " ") {
      // Space key adds category
      e.preventDefault();
      const value = inputValue.trim();
      if (value && value.length > 0) {
        const existingCategory = categoriesData.find(
          (cat) => cat.name.toLowerCase() === value.toLowerCase()
        );

        const categoryToAdd = existingCategory
          ? {
              id: existingCategory.id,
              name: existingCategory.name,
              type: "dropdown",
            }
          : { id: value, name: value, type: "text" };

        setSelectedCategory((prev) => {
          if (
            prev.some(
              (cat) =>
                cat.name.toLowerCase() === categoryToAdd.name.toLowerCase()
            )
          ) {
            return prev;
          }
          return [...prev, categoryToAdd];
        });
        setInputValue("");
        setCategoryDropdownOpen(false);
      }
    } else if (e.key === "Enter") {
      // Enter key adds category AND triggers search
      e.preventDefault();
      const value = inputValue.trim();
      if (value && value.length > 0) {
        const existingCategory = categoriesData.find(
          (cat) => cat.name.toLowerCase() === value.toLowerCase()
        );

        const categoryToAdd = existingCategory
          ? {
              id: existingCategory.id,
              name: existingCategory.name,
              type: "dropdown",
            }
          : { id: value, name: value, type: "text" };

        setSelectedCategory((prev) => {
          if (
            prev.some(
              (cat) =>
                cat.name.toLowerCase() === categoryToAdd.name.toLowerCase()
            )
          ) {
            return prev;
          }
          return [...prev, categoryToAdd];
        });
        setInputValue("");
      }
      setCategoryDropdownOpen(false);
      // Trigger search after a short delay to ensure state updates
      setTimeout(() => {
        // handleSearch();
      }, 100);
    } else if (
      e.key === "Backspace" &&
      inputValue === "" &&
      selectedCategory.length > 0
    ) {
      // Remove last category when backspace is pressed on empty input
      e.preventDefault();
      setSelectedCategory((prev) => prev.slice(0, -1));
    }
  };

  const handleInputFocus = () => {
    setTimeout(() => {
      setCategoryDropdownOpen(true);
    }, 0);
  };

  // UPDATED: handleInputChange function
  const handleInputChange = (e) => {
    const fullValue = e.target.value;
    setInputValue(fullValue);
    setCategoryDropdownOpen(true);
  };

  // UPDATED: handleCategorySelect function
  const handleCategorySelect = (category) => {
    const categoryToAdd = { ...category, type: "dropdown" };
    setSelectedCategory((prev) => {
      if (prev.some((cat) => cat.id === category.id)) {
        return prev;
      }
      return [...prev, categoryToAdd];
    });
    setCategoryDropdownOpen(false);
    setInputValue("");
    // Trigger search after selecting category
    setTimeout(() => {
      // handleSearch();
    }, 100);
  };

  // NEW: Function to remove individual categories
  // const removeCategory = (categoryToRemove) => {
  //   setSelectedCategory((prev) =>
  //     prev.filter((cat) => cat.id !== categoryToRemove.id)
  //   );
  // };

  const filteredCategories = categoriesData.filter((category) =>
    category.name.toLowerCase().includes(inputValue.toLowerCase())
  );

  // const displayValue = selectedCategory.map((cat) => cat.name).join(", ");

  return (
    <>
      <div className="searchcontainer">
        {profiles === undefined && (
          <div class="headerMarketing">
            <h1 className="marketingHeading">
              Find the Perfect Influencer – Effortlessly
            </h1>
            <p>
              Easily discover and connect with the ideal influencers to create
              unique content for your brand
            </p>
          </div>
        )}
        <div className="searchbar-wrap">
          <div className="search-bar !relative">
            <SelectInputFilter
              selected={
                platform.filter((item) => item.id === selectedPlatform).length >
                0
                  ? platform.filter((item) => item.id === selectedPlatform)[0]
                  : ""
              }
              onChange={changeSelectedPlatform}
              list={platform}
              value={
                platform.filter((item) => item.id === selectedPlatform).length >
                0
                  ? platform.filter((item) => item.id === selectedPlatform)[0]
                      .name
                  : "Any"
              }
              setIsOpen={setIsOpen}
              setGenderIsOpen={setGenderIsOpen}
              showConstantLabel={true}
            />
            <div className="devider"></div>
            <div style={{ position: "relative", flex: 1 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "nowrap",
                  gap: "4px",
                  padding: "10px",
                  borderRadius: "18px",
                  backgroundColor: "#fff",
                  overflowX: "auto",
                  scrollbarWidth: "none",
                  whiteSpace: "wrap",
                  width: "420px",
                }}
                className="category-input-container"
              >
                {selectedCategory.map((cat) => (
                  <span key={cat.id} className="whitespace-nowrap p-0">
                    {cat.name}
                  </span>
                ))}
                <input
                  type="text"
                  placeholder={
                    selectedCategory.length === 0
                      ? "Select Categories or Enter handle"
                      : ""
                  }
                  value={inputValue}
                  onFocus={handleInputFocus}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                  style={{
                    flex: 1,
                    width: "120px",
                    border: "none",
                    outline: "none",
                    fontSize: "14px",
                    padding: "4px",
                    backgroundColor: "transparent",
                    whiteSpace: "wrap",
                  }}
                />
                {(selectedCategory.length > 0 || inputValue.trim()) && (
                  <button
                    onClick={() => {
                      setSelectedCategory([]);
                      setInputValue("");
                      setTimeout(() => {
                        handleSearch();
                      }, 100);
                    }}
                    className="!absolute !top-2 !right-2 !w-5 !h-5 !bg-gray-100 !rounded-full !flex !items-center !justify-center"
                  >
                    <X size={15} color="#4B5563" />
                  </button>
                )}
              </div>

              {categoryDropdownOpen && filteredCategories.length > 0 && (
                <div
                  className="category-dropdown"
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    backgroundColor: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    zIndex: 1000,
                    padding: "16px",
                    maxHeight: "300px",
                    overflowY: "auto",
                    marginTop: "4px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "8px",
                    }}
                  >
                    {filteredCategories.map((category, index) => (
                      <span
                        key={`${category.id}-${index}`}
                        onClick={() => handleCategorySelect(category)}
                        style={{
                          padding: "6px 12px",
                          cursor: "pointer",
                          fontSize: "13px",
                          borderRadius: "20px",
                          border: "1px solid #ddd",
                          backgroundColor: "#f8f9fa",
                          color: "#333",
                          transition: "all 0.2s ease",
                          whiteSpace: "nowrap",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "#e9ecef";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "#f8f9fa";
                        }}
                      >
                        {category.name}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <button
              className="search-btn flex item-center justify-center"
              onClick={handleSearch}
            >
              <svg
                data-slot="icon"
                fill="none"
                strokeWidth="1.5"
                stroke="#FFFFFF"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                width={22}
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                ></path>
              </svg>
            </button>
          </div>
          <div className="bg-white border border-gray-300 rounded-3xl px-3 py-2 cursor-pointer flex items-center justify-center gap-2 h-12">
            <SwitchWithLabel
              id="listView"
              labelRight=""
              className="scale-75"
              checked={showList}
              onCheckedChange={() => setShowList(!showList)}
            />
            <div className="flex items-center">
              {!showList ? (
                <LayoutGrid
                  className={`w-4 h-4 ${
                    showList ? "text-green-600" : "text-gray-400"
                  } transition-colors`}
                />
              ) : (
                <List
                  className={`w-4 h-4 ${
                    !showList ? "text-green-600" : "text-gray-400"
                  } transition-colors`}
                />
              )}
            </div>
          </div>
        </div>

        <div className="filters">
          <div className="sort-button-wrap">
            {!isUserHasSubscription && (
              <div className="premium-tag">Premium</div>
            )}
            {selectedPlatform === null ||
            selectedPlatform === "Any" ||
            selectedPlatform === "" ? (
              <Tooltip title="Select a platform first" arrow placement="top">
                <button
                  className={
                    "sort-button" +
                    ((selectedProduct.length > 0 && isOpen === false) ||
                    (selectedProduct.length > 0 && isOpen === true)
                      ? " sort-button-selected"
                      : "")
                  }
                  onClick={toggleDropdown}
                  disabled={
                    selectedPlatform === null ||
                    selectedPlatform === "Any" ||
                    selectedPlatform === "" ||
                    !isUserHasSubscription
                  }
                >
                  Content Type
                  <svg
                    data-slot="icon"
                    className="down-arrow"
                    fill="none"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    width="18"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m19.5 8.25-7.5 7.5-7.5-7.5"
                    ></path>
                  </svg>
                </button>
              </Tooltip>
            ) : (
              <button
                className={
                  "sort-button" +
                  ((selectedProduct.length > 0 && isOpen === false) ||
                  (selectedProduct.length > 0 && isOpen === true)
                    ? " sort-button-selected"
                    : "")
                }
                onClick={toggleDropdown}
                disabled={
                  selectedPlatform === null ||
                  selectedPlatform === "Any" ||
                  selectedPlatform === "" ||
                  !isUserHasSubscription
                }
              >
                Content Type
                <svg
                  data-slot="icon"
                  className="down-arrow"
                  fill="none"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  width="18"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m19.5 8.25-7.5 7.5-7.5-7.5"
                  ></path>
                </svg>
              </button>
            )}
            {isOpen && (
              <div className="dropdown-menu">
                {productList.map((option) => (
                  <div key={option.name} className="dropdown-item">
                    <input
                      type="checkbox"
                      checked={selectedProduct.includes(option.id)}
                      onChange={() => handleCheckboxChange(option)}
                    />
                    <span onClick={() => handleCheckboxChange(option)}>
                      {option.name}
                    </span>
                  </div>
                ))}
                <div className="dropdown-btns">
                  <button onClick={handleButtonClick}>Clear</button>
                  <button onClick={handleSearchNew}>Save</button>
                </div>
              </div>
            )}
          </div>
          <div className="sort-button-wrap">
            {!isUserHasSubscription && (
              <div className="premium-tag">Premium</div>
            )}
            {selectedPlatform === null ||
            selectedPlatform === "Any" ||
            selectedPlatform === "" ? (
              <Tooltip title="Select a platform first" arrow placement="top">
                <button
                  disabled={
                    selectedPlatform === null ||
                    selectedPlatform === "Any" ||
                    selectedPlatform === "" ||
                    !isUserHasSubscription
                  }
                  id="followersButton"
                  className={
                    "sort-button" +
                    (selectedFollowersCount.length > 0
                      ? " sort-button-selected"
                      : "")
                  }
                  onClick={showFollowerModal}
                >
                  Followers
                  <svg
                    data-slot="icon"
                    className="down-arrow"
                    fill="none"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    width="18"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m19.5 8.25-7.5 7.5-7.5-7.5"
                    ></path>
                  </svg>
                </button>
              </Tooltip>
            ) : (
              <button
                disabled={
                  selectedPlatform === null ||
                  selectedPlatform === "Any" ||
                  selectedPlatform === "" ||
                  !isUserHasSubscription
                }
                id="followersButton"
                className={
                  "sort-button" +
                  (selectedFollowersCount.length > 0
                    ? " sort-button-selected"
                    : "")
                }
                onClick={showFollowerModal}
              >
                Followers
                <svg
                  data-slot="icon"
                  className="down-arrow"
                  fill="none"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  width="18"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="m19.5 8.25-7.5 7.5-7.5-7.5"
                  ></path>
                </svg>
              </button>
            )}
          </div>
          <div className="sort-button-wrap">
            {!isUserHasSubscription && (
              <div className="premium-tag">Premium</div>
            )}
            <button
              id="locationButton"
              disabled={!isUserHasSubscription}
              className={
                "sort-button" +
                (selectedLocationData.country.length > 0
                  ? " sort-button-selected"
                  : "")
              }
              onClick={showLocationModal}
            >
              Location
              <svg
                data-slot="icon"
                className="down-arrow"
                fill="none"
                strokeWidth="1.5"
                stroke="currentColor"
                width="18"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m19.5 8.25-7.5 7.5-7.5-7.5"
                ></path>
              </svg>
            </button>
          </div>
          <div className="sort-button-wrap">
            {!isUserHasSubscription && (
              <div className="premium-tag">Premium</div>
            )}
            <button
              id="priceButton"
              disabled={!isUserHasSubscription}
              className={
                "sort-button" +
                (selectedPrice.length > 0 ? " sort-button-selected" : "")
              }
              onClick={showPriceModal}
            >
              Price
              <svg
                data-slot="icon"
                className="down-arrow"
                fill="none"
                strokeWidth="1.5"
                stroke="currentColor"
                width="18"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m19.5 8.25-7.5 7.5-7.5-7.5"
                ></path>
              </svg>
            </button>
          </div>
          <div className="sort-button-wrap">
            {!isUserHasSubscription && (
              <div className="premium-tag">Premium</div>
            )}
            <button
              disabled={!isUserHasSubscription}
              className={
                "sort-button" +
                (selectedGender !== "" && genderIsOpen === false
                  ? " sort-button-selected"
                  : "")
              }
              onClick={toggleDropdownGender}
            >
              Gender
              <svg
                data-slot="icon"
                className="down-arrow"
                fill="none"
                strokeWidth="1.5"
                stroke="currentColor"
                width="18"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m19.5 8.25-7.5 7.5-7.5-7.5"
                ></path>
              </svg>
            </button>
            {genderIsOpen && (
              <div className="dropdown-menu">
                <div className="dropdown-item gender-select">
                  <SelectInput
                    selected={
                      gender.filter((item) => item.value === selectedGender)[0]
                    }
                    onChange={changeSelectedGender}
                    list={gender}
                    value={selectedGender}
                  />
                </div>
                <div className="dropdown-btns">
                  <button onClick={handleClearButtonClick}>Clear</button>
                  <button
                    onClick={() => {
                      handleSearchNew();
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="sort-button-wrap">
            {!isUserHasSubscription && (
              <div className="premium-tag">Premium</div>
            )}
            <button
              id="ageButton"
              disabled={!isUserHasSubscription}
              className={
                "sort-button" +
                (selectedAge !== "" ? " sort-button-selected" : "")
              }
              onClick={showAgeModal}
            >
              Age
              <svg
                data-slot="icon"
                className="down-arrow"
                fill="none"
                strokeWidth="1.5"
                stroke="currentColor"
                width="18"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m19.5 8.25-7.5 7.5-7.5-7.5"
                ></path>
              </svg>
            </button>
          </div>
          <div className="sort-button-wrap">
            <div className="premium-tag">Coming Soon</div>
            <button
              id="ethnicityButton"
              disabled="true"
              className={
                "sort-button" +
                (selectedEthenicity !== "" ? " sort-button-selected" : "")
              }
              onClick={showEthnicityModal}
            >
              Ethnicity
              <svg
                data-slot="icon"
                className="down-arrow"
                fill="none"
                strokeWidth="1.5"
                stroke="currentColor"
                width="18"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m19.5 8.25-7.5 7.5-7.5-7.5"
                ></path>
              </svg>
            </button>
          </div>
          <div className="sort-button-wrap">
            <div className="premium-tag">Coming Soon</div>
            <button
              id="languageButton"
              disabled="true"
              className={
                "sort-button" +
                (selectedLanguage !== "" ? " sort-button-selected" : "")
              }
              onClick={showLanguageModal}
            >
              Language
              <svg
                data-slot="icon"
                className="down-arrow"
                fill="none"
                strokeWidth="1.5"
                stroke="currentColor"
                width="18"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m19.5 8.25-7.5 7.5-7.5-7.5"
                ></path>
              </svg>
            </button>
          </div>

          <button onClick={clearAll} className="clearall-btn">
            Clear All
          </button>
        </div>

        {profiles === undefined && (
          <div className="featured">
            <h2>Featured</h2>
            <p>Collaborate with top influencers across all platforms</p>
          </div>
        )}
        {isLoadedInfluencer &&
          influncerList.length > 0 &&
          (showList ? (
            <ListInfluencerSearch
              influncerList={influncerList}
              setSelectedInfluencer={setSelectedInfluencer}
              handleSearch={handleSearch}
              setToastList={setToastList}
              toastList={toastList}
              addToast={addToast}
              setModal={setModal}
              profiles={profiles}
              setIsUserHasAccessListing={setIsUserHasAccessListing}
              setIsSubscribeModal={setIsSubscribeModal}
              isUserHasSubscription={isUserHasSubscription}
            />
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {influncerList.map((influencer) => (
                <CardInfluencerSearch
                  key={influencer.id}
                  handleSearch={handleSearch}
                  setToastList={setToastList}
                  toastList={toastList}
                  addToast={addToast}
                  setModal={setModal}
                  profiles={profiles}
                  setSelectedInfluencer={setSelectedInfluencer}
                  influencer={influencer}
                  isUserHasSubscription={isUserHasSubscription}
                  setIsUserHasAccessListing={setIsUserHasAccessListing}
                  setIsSubscribeModal={setIsSubscribeModal}
                />
              ))}
            </div>
          ))}

        {isLoadedInfluencer && influncerList.length === 0 && (
          <div>No Influencer Found</div>
        )}
        {paginationData && influncerList.length > 0 && (
          <div className="dashboard__table-footer">
            <PaginationDiscovery
              perPage={paginationData["per_page"]}
              total={paginationData["total"]}
              currentPage={paginationData["current_page"]}
              totalPages={paginationData["total_pages"]}
              onPaginate={onPaginate}
            />
          </div>
        )}
        <AnimatePresence>
          {modal === "followers" && (
            <ModalFollowers
               close={() => setModal(null)}
              setSelectedFollowersCount={setSelectedFollowersCount}
              handleSearch={handleSearch}
              selectedFollowersCount={selectedFollowersCount}
            />
          )}
          {modal === "addtoList" && (
            <ModalAddInfToList
              setToastList={setToastList}
              toastList={toastList}
              close={() => setModal(null)}
              setModal={setModal}
              selectedInfluencer={selectedInfluencer}
              handleSearch={handleSearch}
              cartItem={cartItem}
              closeCartPanel={closeCartPanel}
              setAuth={setAuth}
              user={user}
              NotifModul={NotifModul}
              profiles={profiles}
              setModalNotification={setModalNotification}
              goToPricing={goToPricing}
            />
          )}
          {modal === "addList" && (
            <Modal addClass="addInfToListModal" close={() => setModal(null)}>
              <div className="filterModal modal__camp">
                <AddListandInfluencerToList
                  setToastList={setToastList}
                  toastList={toastList}
                  setTabModal={setModal}
                  selectedInfluencer={selectedInfluencer}
                  handleSearch={handleSearch}
                />
              </div>
            </Modal>
          )}
          {modal === "location" && (
            <ModalLocation
              close={() => setModal(null)}
              countries={countries}
              setSelectedLocationData={setSelectedLocationData}
              selectedLocationData={selectedLocationData}
              handleSearch={handleSearch}
            />
          )}
          {modal === "price" && (
            <ModalPrice
              handleSearch={handleSearch}
              close={() => setModal(null)}
              setSelectedPrice={setSelectedPrice}
              selectedPrice={selectedPrice}
            />
          )}
          ;
          {modal === "age" && (
            <ModalAge
              handleSearch={handleSearch}
              close={() => setModal(null)}
              isUserHasSubscription={isUserHasSubscription}
              setSelectedAge={setSelectedAge}
              selectedAge={selectedAge}
            />
          )}
          ;
          {modal === "ethnicity" && (
            <ModalEthnicity
              handleSearch={handleSearch}
              close={() => setModal(null)}
              isUserHasSubscription={isUserHasSubscription}
              setSelectedEthenicity={setSelectedEthenicity}
              selectedEthenicity={selectedEthenicity}
            />
          )}
          ;
          {modal === "language" && (
            <ModalLanguage
              close={() => setModal(null)}
              isUserHasSubscription={isUserHasSubscription}
              setSelectedLanguage={setSelectedLanguage}
              selectedLanguage={selectedLanguage}
              handleSearch={handleSearch}
            />
          )}
          ;
          {modal === "confirmDelete" && (
            <ModalConfirmDeleteInfluencer
              removeFromList={removeFromList}
              setToastList={setToastList}
              toastList={toastList}
              close={() => setModal(null)}
              setModal={setModal}
              selectedInfluencer={selectedInfluencer}
            />
          )}
          {isSubscribeModal && (
            profiles === undefined ? (
                <ModalSearchSubscription
              goToPricing={() => navigate("/account/pricing")}
              type="account"
              title={"Direct Campaigns"}
              onClose={() => setIsSubscribeModal(false)}
            />
          ):(
            
              <ModalNotSubscribe
              goToPricing={() => navigate("/account/pricing")}
              type="account"
              title={"Direct Campaigns"}
              onClose={() => setIsSubscribeModal(false)}
            />
            )
          )}
        </AnimatePresence>
      </div>
      {toastList && <Toast list={toastList} setList={setToastList} />}
    </>
  );
}
